/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');

require('./PrinterView.css');
var tmplPrinterView = require('./PrinterView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplPrinterView,

  className: 'printer-view container-fluid',

  ui: {
    contentForPrinting: '.content-for-printing'
  },

  regions: {
    contentForPrinting: '@ui.contentForPrinting'
  },

  onBeforeRender: function() {
    // do not replicate this code. Uses global jQuery to make the entire page
    // more printer friendly.
    $('body').addClass('print-friendly');
  },

  onBeforeShow: function() {
    this.showChildView('contentForPrinting', this.options.viewToPrint);
  },

  onDestroy: function() {
    // do not replicate this code. Uses global jQuery to make the remove the
    // printer friendly styles when this view is cleaned up.
    $('body').removeClass('print-friendly');
  }
});
